import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthLayout, Field, inputCls, primaryBtn, ErrorText } from "@/components/AuthLayout";
import { LevelPicker } from "@/pages/Register";
import { useAuth } from "@/context/AuthContext";
import { usePrefs } from "@/context/PrefsContext";
import { api, errMsg } from "@/lib/api";

export default function Onboarding() {
  const { user, setUser } = useAuth();
  const { t } = usePrefs();
  const nav = useNavigate();
  const [code, setCode] = useState("");
  const [level, setLevel] = useState("N4");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      const { data } = await api.post("/auth/onboard", { invitation_code: code, target_level: level });
      setUser(data); nav("/dashboard");
    } catch (ex) { setErr(errMsg(ex)); } finally { setBusy(false); }
  };

  return (
    <AuthLayout title={t("onboardTitle")} subtitle={`${user?.name} · ${t("onboardDesc")}`}>
      <form onSubmit={submit} className="space-y-4" data-testid="onboarding-form">
        <Field label={t("invCode")} id="code"><input id="code" data-testid="onboarding-code-input" required className={`${inputCls} uppercase tracking-widest`} value={code} onChange={(e) => setCode(e.target.value)} placeholder={t("invCodePh")} /></Field>
        <div><span className="mb-1.5 block text-xs font-medium uppercase tracking-wide text-muted-foreground">{t("target")}</span><LevelPicker value={level} onChange={setLevel} testid="onboarding-level" /></div>
        <ErrorText msg={err} id="onboarding-error" />
        <button data-testid="onboarding-submit-button" disabled={busy} className={primaryBtn}>{t("onboardDo")}</button>
      </form>
    </AuthLayout>
  );
}
